import { Flex, Image as ChakraImage, Text } from '@chakra-ui/react';

import { Image } from '../image/image';

const icons: { [key: string]: string } = {
  bca: '/images/bca.png',
  bni: '/images/bni.png',
  bri: '/images/bri.png',
  mandiri: '/images/mandiri.png',
};

type BankIconProps = {
  bank: string;
  inOrderDetail?: boolean;
};

export function BankIcon({ bank, inOrderDetail }: BankIconProps) {
  const bankName = bank.toLowerCase();
  const iconSrc = icons[bankName];

  if (iconSrc) {
    return (
      <Flex
        justifyContent={inOrderDetail ? 'start' : 'center'}
        alignItems={inOrderDetail ? 'start' : 'center'}
        w={
          inOrderDetail
            ? { base: '94px', md: '145px' }
            : { base: '40px', md: '60px' }
        }
      >
        <Image
          as={ChakraImage}
          src={iconSrc}
          alt={bankName}
          objectFit="cover"
        />
      </Flex>
    );
  }

  return (
    <Flex justifyContent="center" alignItems="center" gap="1">
      <ChakraImage
        src="/images/empty-bank-placeholder.svg"
        alt={bankName}
        objectFit="cover"
        w="5"
      />
      <Text textColor="#002FA9" fontWeight="bold" fontSize="md">
        {bank}
      </Text>
    </Flex>
  );
}
